module.exports = __webpack_public_path__ + "img/serifnew_box11.e585018c.jpg";